module.exports = () => {
  Array.reduce = function(fn, initial) {
    let values = this;

    values.forEach((item) => {
      initial = initial !== undefined ? fn(initial, item) : item;
    });

    return initial;
  };
};
